import { scopedKey, markDirty } from "@/storage/session";

// Every per-user blob the app persists. The sync layer walks this list to know
// what to push to and pull from Firestore, so anything added here syncs for
// free — and anything left out silently stays device-local.
export const DATA_KEYS = {
  APP: "tryad_app_v1",
  HISTORY: "tryad_history_v1",
  TRAINING_DATES: "tryad_training_dates_v1",
  BODYWEIGHT: "fitpulse_bodyweight_v1",
  MEASUREMENTS: "tryad_measurements_v1",
  CUSTOM_METRICS: "tryad_custom_metrics_v1",
  WEEKLY_GOAL: "tryad_weekly_goal_v1",
  WEEKS: "tryad_weeks_v1",
  DIET: "tryad_diet_v1",
};

export const ALL_DATA_KEYS = Object.values(DATA_KEYS);

export function readJSON(baseKey, fallback) {
  try {
    const raw = localStorage.getItem(scopedKey(baseKey));
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

// Cuándo se tocó por última vez cada bloque en ESTE dispositivo.
//
// Sin esto, la copia de la nube no se puede comparar con la local y al arrancar
// gana siempre la nube, aunque sea más vieja: es como se perdió el progreso de
// una cuenta cuya subida había fallado. El registro va en su propia clave, que
// no se sincroniza, porque describe a este dispositivo y no al usuario.
const STAMPS_KEY = "tryad_local_stamps_v1";

function readStamps() {
  try {
    return JSON.parse(localStorage.getItem(scopedKey(STAMPS_KEY)) || "{}") || {};
  } catch {
    return {};
  }
}

function stamp(baseKey) {
  try {
    const stamps = readStamps();
    stamps[baseKey] = Date.now();
    localStorage.setItem(scopedKey(STAMPS_KEY), JSON.stringify(stamps));
  } catch {
    // Quedarse sin espacio al anotar la marca no debe impedir el guardado en sí.
  }
}

// 0 cuando no consta: es lo que devuelve para los datos escritos antes de que
// existieran las marcas, y obliga a tratarlos como "no se sabe".
export function lastWrittenAt(baseKey) {
  const value = readStamps()[baseKey];
  return typeof value === "number" ? value : 0;
}

export function writeJSON(baseKey, value) {
  localStorage.setItem(scopedKey(baseKey), JSON.stringify(value));
  stamp(baseKey);
  markDirty(baseKey);
}

export function removeKey(baseKey) {
  localStorage.removeItem(scopedKey(baseKey));
  stamp(baseKey);
  markDirty(baseKey);
}

// Used by the migration path, which reads the old email-scoped keys directly
// rather than through the current (uid-scoped) session.
export function readRawJSON(fullKey) {
  try {
    const raw = localStorage.getItem(fullKey);
    if (!raw) return undefined;
    return JSON.parse(raw);
  } catch {
    return undefined;
  }
}
